import * as Sentry from "@sentry/react";
import ChainedError from "typescript-chained-error";
import { Session } from "../shared/types";

function escape(s: string) {
  return s.replace(/([.*+?^$(){}|[\]/\\])/g, "\\$1");
}

// https://stackoverflow.com/a/25346429
export function getCookie(name: string, cookie: string): string | null {
  try {
    let match = cookie.match(RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)"));
    return match ? match[1] : null;
  } catch (e) {
    throw new ChainedError(
      `Failed to get cookie: ${name} '${cookie}'`,
      e instanceof Error ? e : undefined,
    );
  }
}

function cookieName(): string {
  return window.location.hostname.includes("staging")
    ? "s-process-staging"
    : "s-process";
}

export function hasSessionCookie(): boolean {
  const token = getCookie(cookieName(), document.cookie);

  return !!token;
}

export function getParsedSessionCookie(): Session | null {
  const token = getCookie(cookieName(), document.cookie);

  if (!token) {
    return null;
  }

  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );

    const parsed = JSON.parse(jsonPayload) as Session;
    Sentry.setUser({
      id: parsed.userId,
      username: parsed.userName ?? undefined,
    });
    return parsed;
  } catch (e) {
    console.error("Failed to parse session cookie", e);

    // Clear the cookie
    document.cookie = `${cookieName()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

    return null;
  }
}
